<script setup lang="ts"></script>

<template>
  <img src="/assets/logos_telegram.svg" alt="telegram-qr">
</template>